<template>
    <div>
        <h2 class="encadre">
            <div class="txt_encadre">Cette page vous permet de savoir quelle charte typographique est active sur votre configuration {{ settingObj.name }}.</div>
            <div class="txt_encadre">Vous pouvez télécharger l’ensemble de votre configuration typographique. <a id='downloadall' @click='downloadAll()'>Cliquer ici.</a></div>
        </h2>
        <br/>

        <h1>{{ settingObj.name }} : Charte typographique active</h1>
        <div class="pl-list dictionaries_area">
		    <div class="header">
		        <div class="header_line">
                    <div id="header_col1" class="header_col col1">Nom</div>
                    <!--<div id="header_col2" class="header_col col2">Installé</div>-->
	    	    </div>
		    </div>
        
            <div class="content">

                <charteLine v-for="(charte) in chartes" :key='charte.name' :charteObj='charte' :settingObj='settingObj' ></charteLine>
            
            </div>
		    <div class="footer">
		        <div class="buttons">
		            <button id="btn_addcharte" type="button" class="liste_btn boutonTableau" :title="btnCharteTitle != '' ? btnCharteTitle :'Déposer la charte'" @click='clickBtnAddCharte()' :disabled="isBtnCharteDisabled">Déposer</button>

                    <label id='btn_upload_charte' class="liste_btn boutonTableau" for="upload_charte">Sélectionner un fichier</label>
                    <input id='upload_charte' name='upload_charte' class="input_upload" type="file" :title="btnCharteTitle != '' ? btnCharteTitle :'Sélectionner la charte'" @change="handleCharteFileUpload( $event )" />
                    <div  id='txt_upload_charte'  :class="isBtnCharteDisabled && btnCharteTitle != '' ? 'red' : ''">{{ charteFile != noFile && charteFile != undefined ? charteFile.name : noFile }}</div>

                    <span v-if="isBtnCharteDisabled && btnCharteTitle != ''" class="material-icons icn_errorfile" title="Erreur" @click='cleanCharteFile()'>error_outline</span>
                    <span v-if="!isBtnCharteDisabled && charteFile != noFile" class="material-icons icn_okfile" title="Ok">check</span>
		        </div>
		    </div>
        </div>
        <div class="infodl">
            <div class="txt_infodl">Si vous avez modifié vos chartes typographiques depuis votre client lourd et que vous souhaitez reporter ces modifications sur votre configuration ProLexis WebService, vous pouvez les déposer directement ci-dessus. <u>Attention, leur nom doit être conservé.</u></div>
        </div>
        <br/>
        <hr/>
        <h1>{{ settingObj.name }} : Liste des dictionnaires typographiques</h1>
        <div class="pl-list dictionaries_area">
		    <div class="header">
		        <div class="header_line">
                    <div id="header_col1" class="header_col col1">Nom</div>
                    <!--<div id="header_col2" class="header_col col2">Installé</div>-->
	    	    </div>
		    </div>
        
            <div class="content">

                <typoLine v-for="(typo) in typos" :key='typo.name' :typoObj='typo' :settingObj='settingObj' ></typoLine>
            
            </div>
		    <div class="footer">
		        <div class="buttons">
		            <button id="btn_addtypo" type="button" class="liste_btn boutonTableau" :title="btnTypoTitle != '' ? btnTypoTitle :'Déposer un dictionnaire'" @click='clickBtnAddTypo()' :disabled="isBtnTypoDisabled">Déposer</button>

                    <label id='btn_upload_typo' class="liste_btn boutonTableau" for="upload_typo">Sélectionner un fichier</label>
                    <input id='upload_typo' name='upload_typo' class="input_upload" type="file" @change="handleTypoFileUpload( $event )" :title="btnTypoTitle != '' ? btnTypoTitle :'Sélectionner un dictionnaire'" />
                    <div  id='txt_upload_typo'  :class="isBtnTypoDisabled && btnTypoTitle != '' ? 'red' : ''">{{ typoFile != noFile && typoFile != undefined ? typoFile.name : noFile }}</div>

                    <span v-if="isBtnTypoDisabled && btnTypoTitle != ''" class="material-icons icn_errorfile" title="Erreur" @click='cleanTypoFile()'>error_outline</span>
                    <span v-if="!isBtnTypoDisabled && typoFile != noFile" class="material-icons icn_okfile" title="Ok">check</span>
		        </div>
		    </div>
        </div>
        <div class="infodl">
            <div class="txt_infodl">Si vous avez modifié vos dictionnaires typographiques depuis votre client lourd et que vous souhaitez reporter ces modifications sur votre configuration ProLexis WebService, vous pouvez les déposer directement ci-dessus. <u>Attention, leur nom doit être conservé.</u></div>
        </div>




        <br/>
        <div id="warning">
            <i id="warning_icon" class="material-icons">warning_amber</i>
            <span id="warning_txt"> Tout changement dans cette page sera effectif <u>15 minutes</u> après avoir cliqué sur "Envoyer les modifs" en haut à droite.</span>
        </div>
    </div>
</template>

<script>
    import { diagonalbackURL, defaultConfig, OctetStreamConfig, FormDataConfig } from "../constantes";
    import axios from 'axios'
    import { RoleEnum } from '../classes/enums'
    import FctUtils from '@/components/FctUtils';
    import TypoLine from '@/components/TypoLine';
    import CharteLine from '@/components/CharteLine';

    export default { 
        name:"Typographie",
        components:{
            "charteLine":CharteLine,
            "typoLine":TypoLine,
        },
        mixins: [FctUtils],
        props:{
            settingProps: {type:String}, // arrive depuis un push -> String
        },
        data(){
            
            return {
                noFile:"Aucun fichier choisi",
                
                settingObj: {},
                chartes:{},
                typos: {},
                charteFile: this.noFile,
                typoFile: this.noFile,
                isBtnCharteDisabled : true,
                btnCharteTitle:'',
                isBtnTypoDisabled : true,
                btnTypoTitle:'',
            }
        },
        created() {
            this.charteFile = this.noFile;
            this.typoFile   = this.noFile;

            // Si pas de settings, on regarde s'il n'y en a pas un deja dans le store
            if (!FctUtils.methods.noEmpty(this.settingProps)) {
                this.settingObj = this.$store.getters.setting;
            }
            else {
                this.settingObj = JSON.parse(this.settingProps);
            }

            // Si Setting Ok, on affiche les chartes et les dicos typo correspondants
            if (FctUtils.methods.noEmpty(this.settingObj)) {
                // Recup les chartes associées aux settingID
                axios.get(diagonalbackURL + "/settings/"+this.settingObj.id+"/typography/chartes", defaultConfig)
                    .then(reponse => {
                        this.chartes = reponse.data;
                    })
                    .catch(error => this.errorHandler(error));

                // Recup les dicos typos associées aux settingID
                axios.get(diagonalbackURL + "/settings/"+this.settingObj.id+"/typography/dictionaries", defaultConfig)
                    .then(reponse => {
                        this.typos = reponse.data;
                    })
                    .catch(error => this.errorHandler(error));    
            }
            else {
                // si toujours pas de setting, on retourne vers la selection de la configuration
                this.$router.push({name:"SelectDicoSetting", 
                    params: {
                        from: "Typographie"
                    }
                });
            }
        },
        mounted() {
            this.emitter.on('createCharte', newCharteData => {
                this.createCharte(newCharteData)
            });
            this.emitter.on('removeCharte', aCharteToDelData => {
                this.removeCharte(aCharteToDelData)
            });

            this.emitter.on('createTypo', newTypoData => {
                this.createTypo(newTypoData)
            });
            this.emitter.on('removeTypo', aTypoToDelData => {
                this.removeTypo(aTypoToDelData)
            });
        },
        unmounted() {
            this.emitter.off('createCharte');
            this.emitter.off('removeCharte');
            this.emitter.off('createTypo');
            this.emitter.off('removeTypo');
        },
        methods : {
            isSuperAdmin(){
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            downloadAll() {
                // Telechargement des chartes
                for (const charte of this.chartes) {
                    var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/typography/chartes/" + charte.name;

                    axios(url, OctetStreamConfig)
                    .then(response => {
                        this.downloadFile(charte.name, response.data);
                    })
                    .catch(error => this.errorHandler(error));
                }

                // Telechargement des dicos typos
                for (const typo of this.typos) {
                    var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/typography/dictionaries/" + typo.name;

                    axios(url, OctetStreamConfig)
                    .then(response => {
                        this.downloadFile(typo.name, response.data);
                    })
                    .catch(error => this.errorHandler(error));
                }

            },
            clickBtnAddCharte() {
                //this.emitter.emit('showPLForm', {mode: 'formCharte_new'});
                this.createCharte("");
            },
            // Création du dictionnaire.
            //
            createCharte(aNewCharteData) {
                console.log("Creation de la charte : " + this.charteFile.name)
                var self = this;

                //var filename = encodeURIComponent(this.charteFile.name);

                // Initialize the form data
                let formData = new FormData();

                // Add the form data we need to submit
                formData.append('file', this.charteFile);

                var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/typography/chartes/" + this.charteFile.name);

                axios.put(url, formData, FormDataConfig)
                .then(reponse => {
                    self.charteFile = '';
                    this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            // Suppression d'un dictionnaire.
            //
            removeCharte(toDelCharte) {
                console.log("Suppression de la charte : " + toDelCharte.name)

                var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/typography/chartes/" + toDelCharte.name);

                console.log(defaultConfig);

                axios.delete(url, defaultConfig)
                .then(reponse => {
                    if ((reponse.status == '400') && (typeof reponse.responseJSON.error !== "undefined") && (iJqXHR.responseJSON.error == 'InstalledDico') ) {
                        alert('La charte '+ toDelCharte.name +' doit être désinstallé avant sa suppression.')
                    }
                    else if((reponse.status == '400')) {
                        alert('Echec lors de la suppression de la charte');
                    }
                    else {
                        //alert('Suppression du dictionnaire : ' + toDelCharte.name);
                        this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                        this.$router.go();
                    }
                })
                .catch(error => this.errorHandler(error));
            },
            handleCharteFileUpload(event){
                this.charteFile = event.target.files[0];

                this.isBtnCharteDisabled = true;
                this.btnCharteTitle = '';
                // Il n'y a qu'une seul charte dans la liste
                // Mais au cas ou cela change plus tard
                for (const charte of this.chartes) {
                    if (this.charteFile.name.normalize('NFC') == charte.name.normalize('NFC')) {
                        this.isBtnCharteDisabled = false;
                        break;
                    }
                }

                if (this.isSuperAdmin()) {
                    this.isBtnCharteDisabled = false;
                }

                if (this.isBtnCharteDisabled) {
                    this.btnCharteTitle = 'Fichier incompatible, contacter votre administrateur';
                }
            },
            cleanCharteFile() {
                document.getElementById('upload_charte').value = '';
                this.charteFile = this.noFile;
                this.isBtnCharteDisabled = true;
                this.btnCharteTitle = '';
            },
            ////////////////////////////////////////////////
            ////////////////////////////////////////////////
            clickBtnAddTypo() {
                //this.emitter.emit('showPLForm', {mode: 'formTypo_new'});
                this.createTypo("");
            },
            createTypo(aNewTypoData) {
                console.log("Creation de la charte : " + this.typoFile.name)
                var self = this;

                //var filename = encodeURIComponent(this.typoFile.name);

                // Initialize the form data
                let formData = new FormData();

                // Add the form data we need to submit
                formData.append('file', this.typoFile);

                var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/typography/dictionaries/" + this.typoFile.name);

                axios.put(url, formData, FormDataConfig)
                .then(reponse => {
                    self.typoFile = '';
                    this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            removeTypo(toDelTypo) {
                console.log("Suppression de la charte : "+toDelTypo.name)

                //var filename = encodeURIComponent(toDelTypo.name);

                var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/typography/dictionaries/" + toDelTypo.name);

                axios.delete(url, defaultConfig)
                .then(reponse => {
                    if ((reponse.status == '400') && (typeof reponse.responseJSON.error !== "undefined") && (iJqXHR.responseJSON.error == 'InstalledDico') ) {
                        alert('La charte '+ toDelTypo.name +' doit être désinstallé avant sa suppression.')
                    }
                    else if((reponse.status == '400')) {
                        alert('Echec lors de la suppression de la charte');
                    }
                    else {
                        //alert('Suppression du dictionnaire : ' + toDelTypo.name);
                        this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                        this.$router.go();
                    }
                })
                .catch(error => this.errorHandler(error));

            },
            handleTypoFileUpload(event){
                this.typoFile = event.target.files[0];

                this.isBtnTypoDisabled = true;
                this.btnTypoTitle = '';
                // Il n'y a qu'une seul charte dans la liste
                // Mais au cas ou cela change plus tard
                for (const typo of this.typos) {
                    if (this.typoFile.name.normalize('NFC') == typo.name.normalize('NFC')) {
                        this.isBtnTypoDisabled = false;
                        break;
                    }
                }

                if (this.isSuperAdmin()) {
                    this.isBtnTypoDisabled = false;
                }

                if (this.isBtnTypoDisabled) {
                    this.btnTypoTitle = 'Fichier incompatible, contacter votre administrateur';
                }
            },
            cleanTypoFile() {
                document.getElementById('upload_typo').value = '';
                this.typoFile = this.noFile;
                this.isBtnTypoDisabled = true;
                this.btnTypoTitle = '';
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



.pl-list.dictionaries_area .line {
    width: 100%;
    position: relative;
}

.encadre {
    font-family: "Titillium Web", Arial, Helvetica, sans-serif;
    color : #0075bb;
    margin: auto 0;
}

.txt_encadre {
    text-align: center;
    margin-bottom: 10px;
}
#downloadall {
    cursor: pointer;
}


.buttons {
    position: relative;
    height: 30px;
}


#btn_addcharte, #btn_addtypo {
    position:absolute;
    right : 0;
    margin-right : 5px;
}

#btn_addcharte:disabled, #btn_addtypo:disabled {
    cursor : not-allowed;
}

.input_upload {
    margin-top : 5px;
}

#upload_charte, #upload_typo {
    display: none;
}

#btn_upload_charte, #btn_upload_typo {
    display: inline-block;
    cursor : pointer;
}

#txt_upload_charte, #txt_upload_typo {
    display: inline-block;
    padding-left : 5px;
}

.infodl {
    margin-top:10px;
}

.txt_infodl {
    margin-bottom: 5px;
}

.material-icons.icn_errorfile {
    color : #cc0b00;
    font-size: 20px;
    vertical-align: middle;
    cursor: pointer;
    padding-left: 5px;
}

.material-icons.icn_okfile {
    color : #00aa00;
    font-size: 20px;
    vertical-align: middle;
    padding-left: 5px;
}

</style>
